/*
 * Hero slideshow: loop by swiping past the first / last slide.
 * The drag gives visual feedback (the slides follow the finger a little), then the
 * slideshow fades to the slide on the other end instead of jumping without animation.
 */
(function () {
  if (window.__heroLoopSwipe) return;
  window.__heroLoopSwipe = true;

  var MIN_DISTANCE = 40;
  var MAX_PULL = 56;
  var FADE_MS = 200;
  var start = null;
  var busy = false;

  function findSlideshow(target) {
    return target instanceof Element ? target.closest('slideshow-component[loop-swipe]') : null;
  }

  function scrollerOf(el) {
    return el.querySelector('slideshow-slides');
  }

  function setPull(scroller, px, animate) {
    scroller.style.transition = animate ? 'transform 220ms ease' : 'none';
    scroller.style.transform = px ? 'translateX(' + px + 'px)' : '';
  }

  function begin(x, y, el) {
    if (busy) {
      start = null;
      return;
    }
    start = {
      x: x,
      y: y,
      el: el,
      atStart: el.atStart === true,
      atEnd: el.atEnd === true,
      rtl: getComputedStyle(el).direction === 'rtl',
      pulling: false
    };
  }

  function directionOf(s, dx) {
    var forward = s.rtl ? dx > 0 : dx < 0;
    return forward ? 'next' : 'previous';
  }

  function wrapsIn(s, dir) {
    return (dir === 'next' && s.atEnd) || (dir === 'previous' && s.atStart);
  }

  function move(x, y) {
    var s = start;
    if (!s || busy) return;
    var dx = x - s.x;
    var dy = y - s.y;
    if (!s.pulling && (Math.abs(dx) < 10 || Math.abs(dx) < Math.abs(dy) * 1.5)) return;
    if (!wrapsIn(s, directionOf(s, dx))) return;
    var scroller = scrollerOf(s.el);
    if (!scroller) return;
    s.pulling = true;
    setPull(scroller, Math.max(-MAX_PULL, Math.min(MAX_PULL, dx * 0.35)), false);
  }

  function wrap(el, scroller, index) {
    busy = true;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      setPull(scroller, 0, false);
      el.select(index, undefined, { animate: false });
      busy = false;
      return;
    }

    scroller.style.transition = 'opacity ' + FADE_MS + 'ms ease, transform ' + FADE_MS + 'ms ease';
    scroller.style.transform = '';
    scroller.style.opacity = '0';

    setTimeout(function () {
      el.select(index, undefined, { animate: false });
      requestAnimationFrame(function () {
        scroller.style.opacity = '1';
        setTimeout(function () {
          scroller.style.transition = '';
          scroller.style.opacity = '';
          scroller.style.transform = '';
          busy = false;
        }, FADE_MS + 40);
      });
    }, FADE_MS);
  }

  function finish(x, y) {
    var s = start;
    start = null;
    if (!s) return;

    var scroller = scrollerOf(s.el);
    var dx = x - s.x;
    var dy = y - s.y;
    var horizontal = Math.abs(dx) >= MIN_DISTANCE && Math.abs(dx) >= Math.abs(dy) * 1.5;
    var dir = directionOf(s, dx);
    var canWrap = horizontal && wrapsIn(s, dir) && scroller && typeof s.el.select === 'function';

    if (!canWrap) {
      if (scroller && s.pulling) setPull(scroller, 0, true);
      return;
    }

    var slides = s.el.slides || [];
    if (slides.length < 2) {
      setPull(scroller, 0, true);
      return;
    }

    wrap(s.el, scroller, dir === 'next' ? 0 : slides.length - 1);
  }

  function cancel() {
    var s = start;
    start = null;
    if (!s || !s.pulling) return;
    var scroller = scrollerOf(s.el);
    if (scroller) setPull(scroller, 0, true);
  }

  document.addEventListener('touchstart', function (e) {
    var el = findSlideshow(e.target);
    var t = e.touches && e.touches[0];
    if (el && t && e.touches.length === 1) begin(t.clientX, t.clientY, el);
    else start = null;
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    var t = e.touches && e.touches[0];
    if (t) move(t.clientX, t.clientY);
  }, { passive: true });

  document.addEventListener('touchend', function (e) {
    var t = e.changedTouches && e.changedTouches[0];
    if (t) finish(t.clientX, t.clientY);
  }, { passive: true });

  document.addEventListener('touchcancel', cancel, { passive: true });

  document.addEventListener('mousedown', function (e) {
    if (e.button !== 0) return;
    var el = findSlideshow(e.target);
    if (el) begin(e.clientX, e.clientY, el);
  }, true);

  document.addEventListener('mousemove', function (e) {
    if (start && e.buttons === 1) move(e.clientX, e.clientY);
  }, true);

  document.addEventListener('mouseup', function (e) {
    finish(e.clientX, e.clientY);
  }, true);
})();
